"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FThemeProvider = void 0;
const react_1 = __importDefault(require("react"));
const GlobalStyles_1 = require("./GlobalStyles");
const styled_components_1 = require("styled-components");
const ThemeBuilder_1 = require("./ThemeBuilder");
const FThemeProvider = ({ themeConfig, setThemeConfig, showThemeBuilder = false, children, }) => {
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: themeConfig },
        react_1.default.createElement(ThemeBuilder_1.ThemeBuilder, { config: themeConfig, onChange: (value) => {
                setThemeConfig(Object.assign({}, value));
            } }),
        children,
        react_1.default.createElement(GlobalStyles_1.GlobalStyles, null)));
};
exports.FThemeProvider = FThemeProvider;
//# sourceMappingURL=FThemeProvider.js.map